import pythonApi from '../api/pythonApi';
import { DocumentationApiClient, DocumentationBucket } from './documentationApiClient';

export type { DocumentationBucket };

const multipartConfig = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

class SensorboxDocumentationService implements DocumentationApiClient {
  getDocumentation = async (sensorBoxId: string) => {
    return pythonApi.get(`/api/v1/sensorboxes/${sensorBoxId}/documentation`);
  };

  addModelEntry = async (
    sensorBoxId: string,
    params: { file: File; text?: string; createdAt?: number }
  ) => {
    const formData = new FormData();
    formData.append('file', params.file);
    if (params.text) formData.append('text', params.text);
    if (params.createdAt != null) formData.append('created_at', String(params.createdAt));
    return pythonApi.post(`/api/v1/sensorboxes/${sensorBoxId}/documentation/model`, formData, multipartConfig);
  };

  deleteModelEntry = async (sensorBoxId: string, entryId: string) => {
    return pythonApi.delete(`/api/v1/sensorboxes/${sensorBoxId}/documentation/model/${entryId}`);
  };

  addBucketFiles = async (
    sensorBoxId: string,
    bucket: DocumentationBucket,
    files: File[],
    text?: string,
    createdAt?: number
  ) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    if (text) formData.append('text', text);
    if (createdAt != null) formData.append('created_at', String(createdAt));
    return pythonApi.post(
      `/api/v1/sensorboxes/${sensorBoxId}/documentation/${bucket}/files`,
      formData,
      multipartConfig
    );
  };

  deleteBucketFile = async (sensorBoxId: string, bucket: DocumentationBucket, fileId: string) => {
    return pythonApi.delete(`/api/v1/sensorboxes/${sensorBoxId}/documentation/${bucket}/files/${fileId}`);
  };

  getBucketFileContent = async (
    sensorBoxId: string,
    bucket: DocumentationBucket,
    fileId: string,
    disposition: 'inline' | 'attachment' = 'inline'
  ) => {
    return pythonApi.get(
      `/api/v1/sensorboxes/${sensorBoxId}/documentation/${bucket}/files/${fileId}/content?disposition=${disposition}`,
      { responseType: 'blob' }
    );
  };

  getModelFileContent = async (
    sensorBoxId: string,
    entryId: string,
    disposition: 'inline' | 'attachment' = 'inline'
  ) => {
    return pythonApi.get(
      `/api/v1/sensorboxes/${sensorBoxId}/documentation/model/${entryId}/file/content?disposition=${disposition}`,
      { responseType: 'blob' }
    );
  };
}

const instance = new SensorboxDocumentationService();

export default instance;
